// extracted by mini-css-extract-plugin
export default {"grid":"contact_grid__Xdr6U","fadeIn":"contact_fadeIn__0IXrC","body":"contact_body__JgJWZ","contactMagin":"contact_contactMagin__SsOHs","copyright":"contact_copyright__Nouos"};